import React from 'react';
import ReactDOM from 'react-dom/client';
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    RouterProvider,
    Navigate
} from 'react-router-dom';

import useAuth from "./hooks/useAuth";
import ProtectedRoute from "./components/ProtectedRoute";
import loginForm from "./components/ProtectedRoute";
import { Menu, menu_items } from "./components/Menu";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

import './index.css'

// import Pages
// import * as Pages from "./pages/**" --> ca marche pas, c'est nul
import Home from "./pages/Home"
import Dashboard from "./pages/Dashboard"
import ErrorPage from "./pages/ErrorPage"
import DetailTicket from "./pages/Tickets/DetailTicket"
import FirstLogin from "./pages/FirstLogin";
import ResetPasswordRequest from "./pages/ResetPasswordRequest";
import ResetPassword from "./pages/ResetPassword";
import SuperAdmin from './pages/SuperAdmin';
import CreateAllAccounts from "./pages/CreateAllAccounts";
import config from "./config"

config.customLog();

const SuperAdminRoute = () => {
    const { user } = useAuth();
    return user?.role === 'super_admin' ? <SuperAdmin /> : <Navigate to="/" />;
};

const stylesWarning = [
    'background: #FF0000',
    'border-radius: 3px',
    'color: white',
    'font-weight: bold',
    'padding: 2px 5px'
].join(';')

const _debug = console.debug;

console.debug = function() {
    if (config.getEnv() != 'dev') {
        return function() {};
    }
    return Function.prototype.bind.call(_debug, console, "%cDebug%c", stylesWarning, 'color: inherit');
}();

  
// Créez un objet pour stocker tous les composants
const components = {};

// Utilisez la fonction `require.context` de Webpack pour importer dynamiquement tous les fichiers dans le répertoire
const context = require.context('./pages', true, /\.jsx$/);

context.keys().forEach((key) => {

    // Récupérez le nom du composant en transformant le chemin du fichier en un nom de composant
    // const componentName = key.replace(/^\.\/(.*)\.\w+$/, '$1');
    const componentName = key.replace(/^.*\/(.*)\.\w+$/, '$1');

    // Importez le composant dynamiquement et stockez-le dans l'objet components
    components[componentName] = context(key).default;

});
console.log(components)
// Exportez l'objet components pour l'utiliser dans votre application
export default components;

library.add(fab, fas, far)

// ici import dynamique des éléments du menu
// menu_items.forEach(async (e) => {
//     try {
//         e.component_name = e.url.charAt(0).toUpperCase() + e.url.slice(1)
//         e.module = await import(`./pages/${e.component_name}`);
//         console.log(e);
//     } catch (error) {
//         console.log(error)
//     }
    
// })

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     <BrowserRouter>
//         <App />
//     </BrowserRouter>
// );

// const importElementComponent = (url) => {
//     // console.log(`./${url.charAt(0).toUpperCase() + url.slice(1)}`);
//     return React.lazy(() => import(`./pages/${url.charAt(0).toUpperCase() + url.slice(1)}`));
// };
// const TestComponent = 'Coordonnees';
// console.log(window[TestComponent])
// console.log(eval[TestComponent])
// console.log(eval[Coordonnees])
// console.log(Coordonnees)

// function createComponent(componentName, props, children){
//     var component = React.createElement(eval(componentName), props, children);
//     return component;
//   }

const getComponent = (url, child = false) => {
    var component_name = (child ? child.charAt(0).toUpperCase() + child.slice(1) : '') + url.charAt(0).toUpperCase() + url.slice(1)
    const Component = components[component_name];
    return Component
}

const isFirstLogin = () => {
    // Remplacer par la logique réelle pour vérifier la première connexion (ex: token)
    return localStorage.getItem('firstLogin') === 'true';
};

const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            {/* <Route exact path="/" element={<Home />} errorElement={<ErrorPage />} /> */}

            {/* Redirige vers FirstLogin si c'est la première connexion */}
            <Route
                exact
                path="/"
                element={isFirstLogin() ? <FirstLogin /> : <Home />}
                errorElement={<ErrorPage />}
            />
           
            <Route path="/first-login" element={<FirstLogin />} />
            
            <Route path="/reset-password" element={<ResetPasswordRequest />} />
            <Route path="/reset-password/confirm" element={<ResetPassword />} />
            
            <Route element={<ProtectedRoute />} errorElement={<ErrorPage />} >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin-meosis" element={<SuperAdmin />} />
            <Route path="/create-account-espace-client" element={<CreateAllAccounts />} />
            <Route path="/tickets/liste/:id" element={<DetailTicket />} />

                {menu_items.map((el, index) => {
                    let Component = getComponent(el.url);
                    if (el.children) {
                        return <Route key={index} path={'/' + el.url}>
                                    <Route index element={typeof Component !== 'undefined' ? <Component title={el.name} /> : <ErrorPage />} />
                                    {el.children.map((child, index) => {
                                        let ChildComponent = getComponent(el.url, child)
                                        return <Route key="1" path={'/' + el.url + '/' + child} element={typeof ChildComponent !== 'undefined' ? <ChildComponent /> : <ErrorPage />} />
                                    })}
                                </Route>
                    }
                    else {
                        return <Route key={index} path={'/' + el.url} element={typeof Component !== 'undefined' ? <Component title={el.name} /> : <ErrorPage />} />
                    }
                })}
            </Route>
        </>
    ),
    {
        future: {
            v7_startTransition: true,
            v7_relativeSplatPath: true,
            v7_fetcherPersist: true,
            v7_normalizeFormMethod: true,
            v7_partialHydration: true,
            v7_skipActionErrorRevalidation: true,
        }
    }
);


const toastifyClasses = {
    success: "bg-mdark",
    error: "bg-red-600",
    info: "bg-cyan-500",
    warning: "bg-morange",
    default: "bg-indigo-500",
    dark: "bg-white-600 font-gray-300",
};


// window.addEventListener('error', (event) => {
//     console.error('Global error handler:', event.error);
//     alert('Error')

// });
  

// var component = createComponent('Coordonnees');
ReactDOM.createRoot(document.getElementById("root")).render(
    <>
        <RouterProvider router={router} />
        <ToastContainer
            autoClose="1500"
            theme="colored"
            toastClassName={(context) =>
                toastifyClasses[context?.type || "default"] +
                " relative flex p-3 justify-between overflow-hidden cursor-pointer"
            }
        />
    </>
);

